import React from 'react';
import classNames from 'classnames';
import styles from './Btn.module.less';

export default ({
  primary,
  children,
  disabled,
  style = {},
  size = 'default',
  className,
  handleClick,
}) => {
  const handleClickFunc = () => {
    if (handleClick) {
      handleClick();
    }
  };
  return (
    <div
      className={classNames(
        className,
        primary ? styles.btn_primary : styles.btn_default,
        {
          [styles.disabled]: disabled,
        },
        styles[size],
      )}
      style={style}
      onClick={handleClickFunc}
    >
      {children}
    </div>
  );
};
